<template>
  <div class="bridgeDetails">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>基础信息</span>
        <!-- <el-button
          @click="back()"
          class="back_btn"
          type="primary"
          icon="el-icon-back"
          >返回</el-button
        > -->
      </div>
      <div class="text item">
        <div class="text_item">
          <span>设备名称：</span>
          <span>{{ dateDetails.ormtb602ca03 }}</span>
        </div>
        <div class="text_item2">
          <span>计费规则：</span>
          <span>{{ dateDetails.ormtb608ca01 }}</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>设备编码：</span>
          <span>{{ dateDetails.ormtb602ca00 }}</span>
        </div>
        <div class="text_item2">
          <span>电桩类型：</span>
          <span>{{
            dateDetails.ormtb602ca06 == 1 ? '直流设备' : '交流设备'
          }}</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>所属电站：</span>
          <span>{{ dateDetails.ormtb601ca00 }}</span>
        </div>
        <div class="text_item2">
          <span>所属厂家：</span>
          <span>{{ dateDetails.ormtb602ca01 == 'JS' ? '嘉胜' : '金冠' }}</span>
        </div>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>设备功率：</span>
          <span>{{ dateDetails.ormtb602ca04 + '(Kw)' }}</span>
        </div>
        <div class="text_item2">
          <span>枪口数量：</span>
          <span>{{ dateDetails.ormtb602ca05 }}</span>
        </div>
      </div>
    </el-card>
    <!-- <el-card class="box-card1">
      <div slot="header" class="clearfix">
        <span>资产信息</span>
      </div>
      <div class="text item">
        <div class="text_item">
          <span>设备名称：</span>
          <span>{{ dateDetails.ormtb602ca03 }}</span>
        </div>
        <div class="text_item2">
          <span>计费规则：</span>
          <span>{{ dateDetails.ormtb608ca01 }}</span>
        </div>
      </div>
    </el-card> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      dateDetails: {},
    }
  },
  mounted() {
    console.log(this.$route.query.id)
    let ids = { ormtb602id: this.$route.query.id }
    let url = 'orm/ormtb602/select602Detail'
    this.axios.post(url, ids).then(res => {
      if (res.data.code == 200) {
        console.log('电桩详情', res.data.data)
        this.dateDetails = res.data.data
      }
    })
    // this.dateDetails = JSON.parse(this.$route.query.ormtb602id)
  },
  methods: {
    // back() {
    //   this.$router.back()
    // },
  },
}
</script>

<style scoped>
.bridgeDetails {
  width: 100%;
  height: 800px;
  background: #f3f3f3;
}
.text {
  font-size: 14px;
}
.text_item {
  width: 200px;
}
.text_item2 {
  margin-left: 46%;
}

.item {
  margin-bottom: 18px;
  display: flex;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
  font-weight: 600;
}

.box-card {
  width: 99%;
  margin: 0 auto;
  margin-top: 20px;
  height: 267px;
}
.box-card1 {
  width: 99%;
  margin: 0 auto;
  margin-top: 20px;
  height: 237px;
}
.back_btn {
  float: right;
}
::v-deep .name-header {
  background-color: #e6a23c !important; /* 橙色 */
}
</style>
